// extracted by mini-css-extract-plugin
export var container = "styles-module__container____0xgH";
export var statTitle = "styles-module__statTitle___x7cYv";
export var stat = "styles-module__stat___h2RIn";
export var total = "styles-module__total___o3TQT";
export var statInfo = "styles-module__statInfo___xvZAc";
export var routeColor = "styles-module__routeColor___P0Fnw";